/* unplugin-vue-components disabled */import script from "./ChinaArea.vue?vue&type=script&setup=true&lang=js"
export * from "./ChinaArea.vue?vue&type=script&setup=true&lang=js"

import "./ChinaArea.vue?vue&type=style&index=0&id=13837ac6&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13837ac6"]])

export default __exports__